import PageHeader from "@/components/PageHeader";
import InkEstimatorPanel from "@/components/InkEstimatorPanel";

export default function InkEstimator() {
  return (
    <div data-testid="ink-estimator-page">
      <PageHeader title="Ink / Toner Estimator" eyebrow="Business Control" subtitle="Estimate ink cost by coverage or by analyzing the actual file — calibrates itself from your VersaWorks numbers" />
      <div className="p-8">
        <InkEstimatorPanel />
      </div>
    </div>
  );
}
